import React, { useContext, useEffect } from 'react';
import FormInput from '../../FormInput';
import { AlumnosContext } from '../../../context/alumnos/AlumnosContext';
import { FormWrapper, FormSelect, FormLabel, SubmitButton } from '../../../assets/styled';
	
export const renderGrupoOptions = (categoria) => {
		switch (categoria) {
			case 'INFANTIL':
				return (
					<>
						<option value='13/14'>13/14</option>
						<option value='15/16'>15/16</option>
						<option value='17/18'>17/18</option>
						<option value='19/20/21/22'>19/20/21/22</option>
					</>
				);
			case 'JUVENIL':
				return (
					<>
						<option value='5ta'>5ta</option>
						<option value='4ta'>4ta</option>
						<option value='3ra'>3ra</option>
						<option value='Reserva'>Reserva</option>
						<option value='Primera'>Primera</option>
					</>
				);
			case 'FEMENINO':
				return (
					<>
						<option value='Mayores'>Mayores</option>
						<option value='Primera-Fem'>Primera-Fem</option>
						<option value='Sub-17'>Sub-17</option>
					</>
				);
			case 'MAYORES':
				return (
					<>
						<option value='Mayores'>Mayores</option>
					</>
				);
			default:
				return null;
		}
	};
export default function Formulario({ titulo, handleSubmit, alumnoId }) {
	const alumnoCtx = useContext(AlumnosContext);

	const { handleChangeAlumno, data, getAlumnoById } = alumnoCtx;

	useEffect(() => {
		if (alumnoId) {
			getAlumnoById(alumnoId);
		}
	}, [alumnoId, getAlumnoById]);



	return (
		<FormWrapper>
			<h2 style={title}>{titulo}</h2>
			<form onSubmit={(e) => handleSubmit(e)}>
				<FormInput tipo='nombre' abm />
				<FormInput tipo='apellido' abm />
				<FormInput tipo='dni' abm />
				<div className='mt-4 column'>
					<FormLabel>CATEGORIA</FormLabel>
					<FormSelect
						name='categoria'
						value={data.categoria}
						onChange={(e) => {
							handleChangeAlumno(e);
						}}
					>
						<option value='INFANTIL'>INFANTIL</option>
						<option value='JUVENIL'>JUVENIL</option>
						<option value='FEMENINO'>FEMENINO</option>
						<option value='MAYORES'>MAYORES</option>
					</FormSelect>
				</div>
				<div className='mt-4 column'>
					<FormLabel>GRUPO</FormLabel>
					<FormSelect
						name='grupo'
						value={data.grupo}
						onChange={(e) => {
							handleChangeAlumno(e);
						}}
					>
						<option value=''>Seleccione un grupo</option>
						{renderGrupoOptions(data.categoria)}
					</FormSelect>
				</div>
				<FormInput tipo='fechaNacimiento' abm />
				{alumnoId && (
					<div className='mt-4 column'>
						<FormLabel>ESTADO</FormLabel>
						<FormSelect
							name='activo'
							value={data.activo}
							onChange={(e) => {
								handleChangeAlumno({
									target: {
										name: 'activo',
										value: e.target.value,
									},
									preventDefault: () => {},
								});
							}}
						>
							<option value={true}>Activo</option>
							<option value={false}>Inactivo</option>
						</FormSelect>
					</div>
				)}
				<div className='mt-4'>
					<SubmitButton type='submit'>
						{alumnoId ? 'Guardar Cambios' : 'Crear'}
					</SubmitButton>
				</div>
			</form>
		</FormWrapper>
	);
}
const title = { display: 'flex', justifyContent: 'center' };
